/**
 * Kiki size chart modal — variant picker (delegated, single init).
 */
(function () {
  if (document.documentElement.hasAttribute('data-kiki-size-chart-js')) return;
  document.documentElement.setAttribute('data-kiki-size-chart-js', '');

  var SCROLL_LOCK = 'scroll-lock';

  /**
   * @returns {HTMLDialogElement | null}
   */
  function getOpenDialog() {
    return document.querySelector('dialog.kiki-size-chart-modal[open]');
  }

  function updateScrollLock() {
    if (getOpenDialog()) {
      document.documentElement.setAttribute(SCROLL_LOCK, '');
    } else {
      document.documentElement.removeAttribute(SCROLL_LOCK);
    }
  }

  /**
   * @param {HTMLDialogElement} dialog
   */
  function openDialog(dialog) {
    if (!dialog || dialog.open) return;

    document.querySelectorAll('dialog.kiki-size-chart-modal[open]').forEach(function (other) {
      if (other !== dialog) closeDialog(other);
    });

    dialog.setAttribute('aria-hidden', 'false');
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }

    updateScrollLock();

    var tablesRoot = dialog.querySelector('[data-kiki-size-chart-default-unit]');
    var defaultUnit = tablesRoot
      ? tablesRoot.getAttribute('data-kiki-size-chart-default-unit')
      : 'cm';
    if (defaultUnit !== 'cm' && defaultUnit !== 'inches') {
      defaultUnit = 'cm';
    }
    setActiveUnit(dialog, defaultUnit);

    var closeBtn = dialog.querySelector('[data-kiki-size-chart-close]');
    if (closeBtn instanceof HTMLElement) {
      closeBtn.focus();
    }
  }

  /**
   * @param {HTMLDialogElement} dialog
   */
  function closeDialog(dialog) {
    if (!dialog || !dialog.open) return;

    var trigger = document.querySelector(
      '[data-kiki-size-chart-open][aria-controls="' + dialog.id + '"]'
    );

    dialog.setAttribute('aria-hidden', 'true');
    if (typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }

    updateScrollLock();

    if (trigger instanceof HTMLElement && dialog.contains(document.activeElement)) {
      trigger.focus();
    }
  }

  /**
   * @param {HTMLElement} dialog
   * @param {'cm' | 'inches'} unit
   */
  function setActiveUnit(dialog, unit) {
    var tablesRoot = dialog.querySelector('[data-kiki-size-chart-default-unit]');
    if (!tablesRoot) return;

    dialog.querySelectorAll('[data-kiki-size-chart-unit]').forEach(function (btn) {
      var isActive = btn.getAttribute('data-kiki-size-chart-unit') === unit;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    tablesRoot.querySelectorAll('[data-kiki-size-chart-panel]').forEach(function (panel) {
      var panelUnit = panel.getAttribute('data-kiki-size-chart-panel');
      if (panelUnit === unit) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });
  }

  var SIZE_ORDER = ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'];
  var SIZE_RANGES = {
    bust: [
      { size: 'XS', min: 84, max: 89 },
      { size: 'S', min: 91, max: 97 },
      { size: 'M', min: 99, max: 104 },
      { size: 'L', min: 107, max: 112 },
      { size: 'XL', min: 114, max: 119 },
      { size: 'XXL', min: 124, max: 130 },
      { size: '3XL', min: 132, max: 137 },
    ],
    waist: [
      { size: 'XS', min: 64, max: 69 },
      { size: 'S', min: 71, max: 76 },
      { size: 'M', min: 79, max: 84 },
      { size: 'L', min: 86, max: 91 },
      { size: 'XL', min: 94, max: 99 },
      { size: 'XXL', min: 102, max: 107 },
      { size: '3XL', min: 109, max: 114 },
    ],
    hip: [
      { size: 'XS', min: 89, max: 94 },
      { size: 'S', min: 97, max: 102 },
      { size: 'M', min: 104, max: 109 },
      { size: 'L', min: 112, max: 117 },
      { size: 'XL', min: 119, max: 124 },
      { size: 'XXL', min: 127, max: 132 },
      { size: '3XL', min: 135, max: 140 },
    ],
  };

  /**
   * @param {'bust' | 'waist' | 'hip'} area
   * @param {number} value
   * @returns {string}
   */
  function pickSizeForMeasurement(area, value) {
    var ranges = SIZE_RANGES[area];
    if (value < ranges[0].min) return ranges[0].size;

    for (var i = 0; i < ranges.length; i++) {
      if (value <= ranges[i].max) return ranges[i].size;
    }

    return ranges[ranges.length - 1].size;
  }

  /**
   * @param {HTMLElement} finder
   */
  function showSizeFinderResult(finder) {
    var result = finder.querySelector('[data-ks-size-result]');
    if (!(result instanceof HTMLElement)) return;

    var measurements = {};
    var isValid = true;

    ['bust', 'waist', 'hip'].forEach(function (area) {
      var input = finder.querySelector('[data-ks-size-input="' + area + '"]');
      var rawValue = input instanceof HTMLInputElement ? input.value.replace(',', '.') : '';
      var value = Number(rawValue);

      if (!Number.isFinite(value) || value <= 0) {
        isValid = false;
      }

      measurements[area] = value;
    });

    result.hidden = false;

    if (!isValid) {
      result.classList.add('ks-size-finder__result--error');
      result.innerHTML = 'Please fill in all three measurements.';
      return;
    }

    var recommendedIndex = 0;

    ['bust', 'waist', 'hip'].forEach(function (area) {
      var size = pickSizeForMeasurement(
        /** @type {'bust' | 'waist' | 'hip'} */ (area),
        measurements[area]
      );
      recommendedIndex = Math.max(recommendedIndex, SIZE_ORDER.indexOf(size));
    });

    result.classList.remove('ks-size-finder__result--error');
    result.innerHTML =
      '<strong>Your size: ' +
      SIZE_ORDER[recommendedIndex] +
      '</strong> — based on your largest measurement. Between two sizes? We round up for comfort.';
  }

  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!(target instanceof Element)) return;

    var openBtn = target.closest('[data-kiki-size-chart-open]');
    if (openBtn instanceof HTMLElement) {
      var controls = openBtn.getAttribute('aria-controls');
      if (!controls) return;
      var dialog = document.getElementById(controls);
      if (dialog instanceof HTMLDialogElement) {
        e.preventDefault();
        openDialog(dialog);
      }
      return;
    }

    var closeBtn = target.closest('[data-kiki-size-chart-close]');
    if (closeBtn) {
      var dlg = closeBtn.closest('dialog.kiki-size-chart-modal');
      if (dlg instanceof HTMLDialogElement) {
        e.preventDefault();
        closeDialog(dlg);
      }
      return;
    }

    var unitBtn = target.closest('[data-kiki-size-chart-unit]');
    if (unitBtn instanceof HTMLElement) {
      var parentDialog = unitBtn.closest('dialog.kiki-size-chart-modal');
      var unit = unitBtn.getAttribute('data-kiki-size-chart-unit');
      if (parentDialog instanceof HTMLDialogElement && (unit === 'cm' || unit === 'inches')) {
        e.preventDefault();
        setActiveUnit(parentDialog, unit);
      }
      return;
    }

    var finderBtn = target.closest('[data-ks-size-finder-button]');
    if (finderBtn instanceof HTMLElement) {
      var finder = finderBtn.closest('[data-ks-size-finder]');
      if (finder instanceof HTMLElement) {
        e.preventDefault();
        showSizeFinderResult(finder);
      }
    }
  });

  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!(target instanceof Element)) return;
    if (target.tagName !== 'DIALOG' || !target.classList.contains('kiki-size-chart-modal')) return;
    if (target !== getOpenDialog()) return;

    var rect = target.getBoundingClientRect();
    var inPanel = target.querySelector('.kiki-size-chart-modal__panel');
    if (!inPanel) return;

    var panelRect = inPanel.getBoundingClientRect();
    var x = e.clientX;
    var y = e.clientY;
    var outsidePanel =
      x < panelRect.left || x > panelRect.right || y < panelRect.top || y > panelRect.bottom;

    if (outsidePanel) {
      closeDialog(/** @type {HTMLDialogElement} */ (target));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = getOpenDialog();
    if (open) {
      e.preventDefault();
      closeDialog(open);
    }
  });

  document.addEventListener('close', function (e) {
    var dialog = e.target;
    if (!(dialog instanceof HTMLDialogElement)) return;
    if (!dialog.classList.contains('kiki-size-chart-modal')) return;
    dialog.setAttribute('aria-hidden', 'true');
    updateScrollLock();
  });

  document.addEventListener('shopify:section:load', function () {
    updateScrollLock();
  });
})();
